import React from 'react';
import { Button, type ButtonProps } from '@mui/material';
import translation from 'i18n/translation.json';

interface ButtonContainedProps extends ButtonProps {
  label?: string | React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export const ButtonContained = ({
  loading,
  disabled,
  label = translation.continue,
  size = 'large',
  ...rest
}: ButtonContainedProps) => {
  /* eslint-disable */
  return (
    <Button variant="contained" fullWidth size={size} disabled={loading || disabled} loading={loading} {...rest}>
      {!loading && label}
    </Button>
  );
};
